import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import { BASE_URL, CDN_BASE_URL } from "../../../config";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { FaPlus } from "react-icons/fa";
import Loading from "../Loading";

const EditAdminForm = () => {
  const [brands, setBrands] = useState();
  const [img, setImg] = useState();
  const [img2, setImg2] = useState();
  const [previewImg, setPreviewImg] = useState();
  const [previewImg2, setPreviewImg2] = useState();
  const [loading, setloading] = useState();
  const [selectedBrand, setselectedBrand] = useState();

  useEffect(() => {
    stayLogin();
  }, []);

  async function stayLogin() {
    await httpReauest("GET", "/partner/getall", {}, {}).then(({ data }) => {
      setBrands(data?.data);
    });
  }

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      username: Yup.string().required("الزامی است"),
      name: Yup.string().required("الزامی است"),
      phone: Yup.string().required("الزامی است"),
    });
  };
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      name: "",
      phone: "",
      nationalCode: "",
      address: "",
      state: "",
      city: "",
      postalCode: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setloading(true);
      const user = JSON.parse(localStorage.getItem("user"));

      await httpReauest("PUT", "/partner/edit/" + selectedBrand._id, values, {
        "x-access-token": user.token,
      })
        .then((dat) => {
          if (dat?.status == 201) {
            toast.success("ادمین تغییر شد");
            setloading(false);
            formik.resetForm();
          }
        })
        .catch((err) => {
          setloading(false);
          toast.error(err.response?.data?.message);
        });
    },
  });

  async function handleDelete(params) {
    const user = JSON.parse(localStorage.getItem("user"));
    await fetch(BASE_URL + "/partner/" + selectedBrand?._id, {
      method: "DELETE",
      headers: { "x-access-token": user.token },
    })
      .then((dat) => {
        if (dat?.status == 201) {
          toast.success("ادمین حذف شد");
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
      });
  }

  async function handleChange(e) {
    const newBrand = await brands.find((value) => value._id == e.target.value);

    setselectedBrand(newBrand);
    const keys = Object.keys(newBrand);

    keys.map((value) => formik.setFieldValue(value, newBrand[value]));
  }

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">فرم تغییر پارتنر</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
      >
        <span className="relative">
          <select
            id="brand"
            name="brand"
            onChange={handleChange}
            className={` w-full form-brand h-[48px]`}
          >
            <option></option>
            {brands?.map((e) => {
              if (!e.end) {
                return <option value={e._id}>{e.username}</option>;
              }
            })}
          </select>
          <p className="on-border font-bold">انتخاب ادمین*</p>
        </span>
        {selectedBrand && (
          <>
            <span className="relative">
              <input
                id="username"
                name="username"
                value={formik.values.username}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.username && formik.touched.username && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.username}
                </small>
              )}
              <p className="on-border font-bold">نام کاربری(انگلیسی)*</p>
            </span>
            <span className="relative">
              <input
                id="password"
                name="password"
                type="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.password && formik.touched.password && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.password}
                </small>
              )}
              <p className="on-border font-bold">رمز عبور*</p>
            </span>
            <span className="relative">
              <input
                id="name"
                name="name"
                type="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.name && formik.touched.name && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.name}
                </small>
              )}
              <p className="on-border font-bold">اسم*</p>
            </span>
            <span className="relative">
              <input
                id="phone"
                name="phone"
                type="phone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.phone && formik.touched.phone && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.phone}
                </small>
              )}
              <p className="on-border font-bold">شماره تلفن*</p>
            </span>

            <span className="relative">
              <input
                id="nationalCode"
                name="nationalCode"
                type="nationalCode"
                value={formik.values.nationalCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.nationalCode && formik.touched.nationalCode && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.nationalCode}
                </small>
              )}
              <p className="on-border font-bold">کدملی*</p>
            </span>

            <span className="relative">
              <input
                id="state"
                name="state"
                type="state"
                value={formik.values.state}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.state && formik.touched.state && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.state}
                </small>
              )}
              <p className="on-border font-bold">استان*</p>
            </span>

            <span className="relative">
              <input
                id="city"
                name="city"
                type="city"
                value={formik.values.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.city && formik.touched.city && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.city}
                </small>
              )}
              <p className="on-border font-bold">شهر*</p>
            </span>

            <span className="relative">
              <input
                id="postalCode"
                name="postalCode"
                type="postalCode"
                value={formik.values.postalCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.postalCode && formik.touched.postalCode && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.postalCode}
                </small>
              )}
              <p className="on-border font-bold">کد پستی*</p>
            </span>

            <span className="relative">
              <input
                id="address"
                name="address"
                type="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.address && formik.touched.address && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.address}
                </small>
              )}
              <p className="on-border font-bold">آدرس*</p>
            </span>
            <span className="col-span-full flex gap-4">
              {loading ? (
                <Loading />
              ) : (
                <>
                  <button className="btn-brand">تغییر ادمین</button>
                  <button
                    type="button"
                    onClick={handleDelete}
                    className=" btn-brand-outline"
                  >
                    {" "}
                    حذف ادمین
                  </button>
                </>
              )}
            </span>
          </>
        )}
      </form>
    </div>
  );
};

export default EditAdminForm;
